export const ADDRESS_SCHEMA = ['street', 'houseNumberOrName', 'postalCode', 'city', 'stateOrProvince', 'country'];
export const COUNTRIES_WITH_STATES_DATASET = ['BR', 'CA', 'US'];
